import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import carRepair from '../assets/success/case-car-repair.svg';
import restaurantEquipment from '../assets/success/restaurant-equipment.svg';
import homeRepair from '../assets/success/home-repair.svg';
import studentLaptop from '../assets/success/student-laptop.svg';
import debtConsolidation from '../assets/success/debt-consolidation.svg';
import petMedical from '../assets/success/pet-medical.svg';

const Services: React.FC = () => {

  return (
    <HelmetProvider>
      <SEO
        title="成功案例"
        description="好野貸撥款成功案例，專注 1~10 萬元小額貸款方案：快速審核、彈性還款、實際效益，涵蓋車禍修繕、設備購置、老屋修繕、學生急用、債務整合、醫療急用等多元需求。"
        keywords={[
          '成功案例', '小額貸款', '快速撥款', '彈性還款', '好野貸',
          '1萬', '3萬', '5萬', '6萬', '8萬', '10萬'
        ]}
        canonicalUrl="https://haoyedai.com/services"
      />
      <Layout>
      <section className="py-16 bg-gradient-to-r from-black via-neutral-900 to-black text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 tracking-tight">成功案例</h1>
          <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto">
            專注於 1~10 萬元小額貸款方案，強調快速審核、彈性還款與實際效益，
            以下為好野貸的真實核貸與撥款案例，協助您快速了解申辦成果。
          </p>
      </div>
      </section>

      

      {/* Success Stories Section */}
      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900">好野貸 撥款成功案例</h2>
            <p className="text-gray-600 mt-4">專注推廣 1~10 萬元小額貸款方案，強調快速審核、彈性還款與實際效益。</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Case 1 */}
            <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100">
              <img src={carRepair} alt="車禍維修－當日撥款3萬元" className="w-16 h-16 mb-4" loading="lazy" width={64} height={64} />
              <div className="flex items-center mb-4">
                <div className="bg-brand-gold-100 text-brand-gold-700 p-3 rounded-lg mr-3" aria-hidden="true"></div>
                <h3 className="text-xl font-semibold text-gray-900">【核貸3萬元案例】</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                黃小姐從事兼職工作未滿三個月，突遇車禍需支付3萬元維修費。因保險未理賠且信用條件有限，透過好野貸快速審核機制，當日即成功撥款3萬元，立即解決理賠問題！
              </p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <span className="bg-brand-gold-50 text-brand-gold-700 px-3 py-1 rounded-full mr-2">核貸金額：3萬元</span>
                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full">撥款速度：當日</span>
              </div>
            </div>

            {/* Case 2 */}
            <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100">
              <img src={restaurantEquipment} alt="餐廳設備購置－24小時核貸5萬元" className="w-16 h-16 mb-4" loading="lazy" width={64} height={64} />
              <div className="flex items-center mb-4">
                <div className="bg-brand-gold-100 text-brand-gold-700 p-3 rounded-lg mr-3" aria-hidden="true"></div>
                <h3 className="text-xl font-semibold text-gray-900">【核貸5萬元急用金】</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                陳先生餐廳臨時需購置設備，但創業初期資金吃緊。好野貸專員評估後，24小時內核貸5萬元，低月付方案讓小店順利度過難關，現在已穩定經營！
              </p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <span className="bg-brand-gold-50 text-brand-gold-700 px-3 py-1 rounded-full mr-2">核貸金額：5萬元</span>
                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full">撥款速度：24小時</span>
              </div>
            </div>

            {/* Case 3 */}
            <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100">
              <img src={homeRepair} alt="老屋漏水修繕－2工作天撥款8萬元" className="w-16 h-16 mb-4" loading="lazy" width={64} height={64} />
              <div className="flex items-center mb-4">
                <div className="bg-brand-gold-100 text-brand-gold-700 p-3 rounded-lg mr-3" aria-hidden="true"></div>
                <h3 className="text-xl font-semibold text-gray-900">【核貸8萬元週轉案例】</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                張太太家中老屋突發漏水，裝修預算短缺。憑藉好野貸彈性還款方案，僅用薪轉帳戶即成功申貸8萬元，從申請到撥款僅2工作天，解決燃眉之急！
              </p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <span className="bg-brand-gold-50 text-brand-gold-700 px-3 py-1 rounded-full mr-2">核貸金額：8萬元</span>
                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full">撥款速度：2工作天</span>
              </div>
            </div>

            {/* Case 4 */}
            <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100">
              <img src={studentLaptop} alt="學生筆電急用－超低利率分12期" className="w-16 h-16 mb-4" loading="lazy" width={64} height={64} />
              <div className="flex items-center mb-4">
                <div className="bg-brand-gold-100 text-brand-gold-700 p-3 rounded-lg mr-3" aria-hidden="true"></div>
                <h3 className="text-xl font-semibold text-gray-900">【核貸1萬元小額應急】</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                大學生李同學筆電損壞影響課業，透過好野貸學生專案，憑打工收入證明即獲1萬元資金，超低利率分12期償還，輕鬆負擔不影響生活！
              </p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <span className="bg-brand-gold-50 text-brand-gold-700 px-3 py-1 rounded-full mr-2">核貸金額：1萬元</span>
                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full">撥款速度：審核通過即撥款</span>
              </div>
            </div>

            {/* Case 5 */}
            <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100">
              <img src={debtConsolidation} alt="債務整合－單一利率4.99%核貸10萬元" className="w-16 h-16 mb-4" loading="lazy" width={64} height={64} />
              <div className="flex items-center mb-4">
                <div className="bg-brand-gold-100 text-brand-gold-700 p-3 rounded-lg mr-3" aria-hidden="true"></div>
                <h3 className="text-xl font-semibold text-gray-900">【核貸10萬元整合負債】</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                王先生因多筆小額貸款管理困難，好野貸提供債務整合方案，單一利率4.99%核貸10萬元，每月省下$2,300利息支出，財務狀況明顯改善！
              </p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <span className="bg-brand-gold-50 text-brand-gold-700 px-3 py-1 rounded-full mr-2">核貸金額：10萬元</span>
                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full">撥款速度：審核通過即撥款</span>
              </div>
            </div>

            {/* Case 6 */}
            <div className="bg-gray-50 rounded-xl shadow-sm p-6 border border-gray-100">
              <img src={petMedical} alt="寵物醫療急用－6小時快速撥款6萬元" className="w-16 h-16 mb-4" loading="lazy" width={64} height={64} />
              <div className="flex items-center mb-4">
                <div className="bg-brand-gold-100 text-brand-gold-700 p-3 rounded-lg mr-3" aria-hidden="true"></div>
                <h3 className="text-xl font-semibold text-gray-900">【核貸6萬元醫療急用】</h3>
              </div>
              <p className="text-gray-700 leading-relaxed">
                趙小姐寵物急需手術，好野貸寵物醫療專案6小時快速撥款6萬元，無需擔保品，分期付款配合獸醫療程規劃，毛孩順利恢復健康！
              </p>
              <div className="mt-4 flex items-center text-sm text-gray-500">
                <span className="bg-brand-gold-50 text-brand-gold-700 px-3 py-1 rounded-full mr-2">核貸金額：6萬元</span>
                <span className="bg-emerald-50 text-emerald-600 px-3 py-1 rounded-full">撥款速度：6小時</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-black text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            準備好申請了嗎？
          </h2>
          <p className="text-xl text-gray-300 mb-8 max-w-2xl mx-auto">
            無論您選擇哪種服務，我們都將為您提供最專業的諮詢和最優惠的方案。
            立即加入 LINE 官方帳號，開始您的貸款申請流程。
          </p>
          <a
            href="https://line.me/R/ti/p/@939rzwem"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center bg-white text-brand-gold-700 px-8 py-4 rounded-lg text-lg font-semibold hover:bg-brand-gold-50 transition-colors duration-200 shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-brand-gold-500"
          >
            <svg className="w-6 h-6 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
            </svg>
            立即諮詢
          </a>
        </div>
      </section>
    </Layout>
    </HelmetProvider>
  );
};

export default Services;